import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
// import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import LogsByDay from "./pages/LogsByDay";
import LogsSlow from "./pages/LogsSlow";
import UserTracking from "./pages/UserTracking";
import RequireAuth from "./components/RequireAuth";

export default function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route
                    path="/"
                    element={
                        <RequireAuth>
                            <Homepage />
                        </RequireAuth>
                    }
                >
                    <Route index element={<Navigate to="user-tracking" replace />} />
                    <Route path="logs-by-day" element={<LogsByDay />} />
                    <Route path="logs-slow" element={<LogsSlow />} />
                    <Route path="user-tracking" element={<UserTracking />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
